import React from 'react';
import PropTypes from 'prop-types';
// constants
import ROLES from '../../constants/Roles';
// -- list and menu:
import ListView from '../Common/ListView.react';
import EventListItem from './ModuleEventListItem';
// -- icons:
import EventIcon from 'material-ui/svg-icons/action/event';
import PersonIcon from 'material-ui/svg-icons/social/person';
import InfoIcon from 'material-ui/svg-icons/action/info';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import EnrolmentIcon from 'material-ui/svg-icons/action/check-circle';

//business logic:
import buildContextMenu from '../Common/BuildContextMenu';

import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleEventStore from '../../stores/ModuleEventStore';
import ModuleStore from '../../stores/ModuleStore';
import EventAttendeeStore from '../../stores/EventAttendeeStore';
import { withId } from '../Common/Decorators';

const getMenuItems = (id) => [
    {
        link: `/dashboard/module/${id}`,
        icon: <InfoIcon/>,
        label: 'Preview'
    },
    {
        link: `/dashboard/module/${id}/calendar`,
        icon: <EventIcon/>,
        label: 'Calendar'
    },
    { type: 'divider' },
    {
        link: `/dashboard/module/${id}/enrolments`,
        icon: <EnrolmentIcon/>,
        label: 'Enrolments',
        condition: {
            roles: [ROLES.MANAGER]
        }
    },
    { type: 'divider' },
    {
        link: `/dashboard/module/${id}/settings`,
        icon: <SettingsIcon/>,
        label: 'Settings',
        condition: {
            roles: [ROLES.MANAGER]
        }
    }
];

const ModuleEvents = React.createClass({

    getInitialState: function(){
        return {
            dialog: {
                open: false,
                value: null,
                data: null
            },

            open: false,
            searchText: '',
            details: {
                name: '',
                description: '',
                outline: '',
                instruction: '',
                cost: '',
                url: '',
                assessment: '',
                type: '',
                moduleStatus: '',
                code: '',
                capacity: '',
                access: {}
            },
            enrolments: [],
            events: [],
            dataSource: {
                users: [],
                statuses: ModuleStore.getStatuses()
            },

            actions: [],

            links: {
                back: `/dashboard/module/${this.props.id}`,
                edit: '',

            }
        }
    },

    componentWillMount() {
        this.setState({actions: buildContextMenu(getMenuItems(this.props.id), this.context.auth)});
    },

    componentDidMount: function(){
        this.listeners = [
            ModuleStore.addListener(this._onModuleChange),
            ModuleEventStore.addListener(this._onEventChange),
            EventAttendeeStore.addListener(this.onAttendanceChange),
        ];
        ModuleActions.getById(this.props.id);
        ModuleActions.getEvents(this.props.id, {limit: 0});


    },

    componentWillUnmount: function() {
        this.listeners.forEach( listener => listener.remove() );
    },

    render: function(){

        const canEdit = this.context.auth.isAdmin() && this.context.auth.canEdit(this.state.details.access);
        const newEntityUrl = canEdit ? `/dashboard/module/${this.props.id}/event/new` : null;

        return (

            <ListView
                title={this.state.details.name}
                items={this.state.events}
                itemDecorator={EventListItem}
                actions={this.state.actions}
                newEntityUrl={newEntityUrl}
            />

        );
    },

    _onModuleChange: function() {
        const details = ModuleStore.getById(this.props.id);
        if (details !== undefined) {
            this.setState({details});
        }
    },
    _onEventChange: function() {
        const events  = ModuleEventStore.getByModule(this.props.id);
        if (events !== undefined) {
            const sortMap = events
                .map(({timeStart}, index) => ({index, timeStart}))
                .sort((a, b) => b.timeStart - a.timeStart);
            this.setState({events: sortMap.map(({index}) => events[index])});
        }
    },
    onAttendanceChange: function () {
        // triggered by an action in the listItems
        ModuleActions.getEvents(this.props.id);
    }


});

ModuleEvents.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(ModuleEvents);
